import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
import "./ManageStatusModal.scss";

export function ManageStatusModal({ submit, ...props }) {
  const [t] = useTranslation();
  const [bookStatus, setBookStatus] = useState(false);

  return (
    <Modal {...props} centered dialogClassName="manage-status-modal">
      <Modal.Header className="manage-status-modal-header" closeButton>
        <div className="title">{t("ManageSchoolBookStatus")}</div>
      </Modal.Header>
      <Modal.Body className="manage-status-modal-content">
        <div className="sub-title">{t("ManageSchoolBookStatusText")}</div>
        <div
          className="book-status-wrapper"
          onClick={() => setBookStatus(!bookStatus)}
        >
          <div className="checkbox">
            {bookStatus ? "check_box" : "check_box_outline_blank"}
          </div>
          <div className="label">{t("BookStatus")}</div>
        </div>
        <div className="button-wrapper">
          <Button className="button-cancel" onClick={() => props.onHide()}>
            {t("Close")}
          </Button>
          <Button
            className="button"
            onClick={() => {
              submit(bookStatus);
            }}
          >
            {t("Change")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
